export const PASSWORD_SYMBOLS = "@#$&=";

export type PasswordRule = {
  id: string;
  label: string;
  test: (password: string) => boolean;
};

export const PASSWORD_RULES: PasswordRule[] = [
  {
    id: "length",
    label: "At least 8 characters",
    test: (password) => password.length >= 8,
  },
  {
    id: "lower",
    label: "Includes a lowercase letter",
    test: (password) => /[a-z]/.test(password),
  },
  {
    id: "upper",
    label: "Includes an uppercase letter",
    test: (password) => /[A-Z]/.test(password),
  },
  {
    id: "symbol",
    label: `Includes a symbol (${PASSWORD_SYMBOLS.split("").join(", ")})`,
    test: (password) => /[@#$&=]/.test(password),
  },
];

export function isPasswordValid(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}

export function passwordValidationError(password: string): string | null {
  const failed = PASSWORD_RULES.find((rule) => !rule.test(password));
  return failed ? failed.label : null;
}
